export default __webpack_public_path__ + "static/media/24.6c64151a.jpg";